/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {
  DownloadRenderItem200,
  GetRenderHistoryParams,
  RenderHistoryResponse,
  RenderItemConfigResponse,
  RenderRequest,
  RenderResponse,
} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Records a render export, charges credits, and creates a background render job.
 */
export type createRenderResponse200 = {
  data: RenderResponse
  status: 200
}

export type createRenderResponseSuccess = createRenderResponse200 & {
  headers: Headers
}
export type createRenderResponse = createRenderResponseSuccess

export const getCreateRenderUrl = () => {
  return `/renders`
}

export const createRender = async (
  renderRequest: RenderRequest,
  options?: RequestInit,
): Promise<createRenderResponse> => {
  return customFetch<createRenderResponse>(getCreateRenderUrl(), {
    ...options,
    method: 'POST',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(renderRequest),
  })
}

/**
 * List the current user's render history (paginated).
 */
export type getRenderHistoryResponse200 = {
  data: RenderHistoryResponse
  status: 200
}

export type getRenderHistoryResponseSuccess = getRenderHistoryResponse200 & {
  headers: Headers
}
export type getRenderHistoryResponse = getRenderHistoryResponseSuccess

export const getGetRenderHistoryUrl = (params?: GetRenderHistoryParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : String(v)))
      } else {
        normalizedParams.append(key, value === null ? 'null' : value.toString())
      }
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/renders/history?${stringifiedParams}` : `/renders/history`
}

export const getRenderHistory = async (
  params?: GetRenderHistoryParams,
  options?: RequestInit,
): Promise<getRenderHistoryResponse> => {
  return customFetch<getRenderHistoryResponse>(getGetRenderHistoryUrl(params), {
    ...options,
    method: 'GET',
  })
}

/**
 * Get a presigned download URL for a completed render item.
 */
export type downloadRenderItemResponse200 = {
  data: DownloadRenderItem200
  status: 200
}

export type downloadRenderItemResponseSuccess = downloadRenderItemResponse200 & {
  headers: Headers
}
export type downloadRenderItemResponse = downloadRenderItemResponseSuccess

export const getDownloadRenderItemUrl = (itemId: string) => {
  return `/renders/history/${itemId}/download`
}

export const downloadRenderItem = async (
  itemId: string,
  options?: RequestInit,
): Promise<downloadRenderItemResponse> => {
  return customFetch<downloadRenderItemResponse>(getDownloadRenderItemUrl(itemId), {
    ...options,
    method: 'GET',
  })
}

/**
 * Queue (or re-queue) a render for an item on demand. Serves both the initial
"Request render" of a prepared SNAPSHOT item and the "Retry" of a FAILED one.
 */
export type requestRenderResponse204 = {
  data: void
  status: 204
}

export type requestRenderResponseSuccess = requestRenderResponse204 & {
  headers: Headers
}
export type requestRenderResponse = requestRenderResponseSuccess

export const getRequestRenderUrl = (itemId: string) => {
  return `/renders/history/${itemId}/render`
}

export const requestRender = async (itemId: string, options?: RequestInit): Promise<requestRenderResponse> => {
  return customFetch<requestRenderResponse>(getRequestRenderUrl(itemId), {
    ...options,
    method: 'POST',
  })
}

/**
 * Delete a render item — removes its stored render data and the rendered image.
 */
export type deleteRenderResponse204 = {
  data: void
  status: 204
}

export type deleteRenderResponseSuccess = deleteRenderResponse204 & {
  headers: Headers
}
export type deleteRenderResponse = deleteRenderResponseSuccess

export const getDeleteRenderUrl = (itemId: string) => {
  return `/renders/history/${itemId}`
}

export const deleteRender = async (itemId: string, options?: RequestInit): Promise<deleteRenderResponse> => {
  return customFetch<deleteRenderResponse>(getDeleteRenderUrl(itemId), {
    ...options,
    method: 'DELETE',
  })
}

/**
 * Internal endpoint — returns the scene config for a render item (used by Puppeteer).
No authentication required (UUID-gated).
 */
export type getRenderItemConfigResponse200 = {
  data: RenderItemConfigResponse
  status: 200
}

export type getRenderItemConfigResponseSuccess = getRenderItemConfigResponse200 & {
  headers: Headers
}
export type getRenderItemConfigResponse = getRenderItemConfigResponseSuccess

export const getGetRenderItemConfigUrl = (itemId: string) => {
  return `/renders/internal/${itemId}/config`
}

export const getRenderItemConfig = async (
  itemId: string,
  options?: RequestInit,
): Promise<getRenderItemConfigResponse> => {
  return customFetch<getRenderItemConfigResponse>(getGetRenderItemConfigUrl(itemId), {
    ...options,
    method: 'GET',
  })
}
